import "./TimeInput.scss";

export default {
  name: "TimeInput",
  props: [
    "label",
    "value",
    "disabled",
    "appendIcon",
    "resetOptionOff",
    "error"
  ],
  data: () => ({
    showMenu: false,
    sTime: null,
    mainPeacock: "#00636C"
  }),
  methods: {
    setValue({ target }) {
      this.inputValue = target.value;
    },
    resetValue() {
      this.$emit("changeValue", "");
    }
  },
  watch: {
    showMenu(value) {
      if (!value) this.$refs.menu.save(this.time);
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        if (val) this.$emit("changeValue", val);
      }
    },
    time: {
      get() {
        return this.sTime || this.value;
      },
      set(val) {
        this.sTime = val;
      }
    }
  }
};
